import { format } from 'date-fns';
import { translate } from 'hooks/useTranslate';

import { DATE_FORMAT } from 'constants/defaultConstants';
import operationTypesRealNames from 'constants/operationTypesRealNames';

import { OperationData } from '../types/CustomOperation';
import { operationPositions } from '../constants/operationPositions';

export const getOperationTooltip = (
  operationPosition: string,
  operationData: OperationData
) => {
  const operationLabel =
    operationPosition === operationPositions.PREVIOUS
      ? translate('PreviousOperation')
      : translate('NextOperation');

  const operationDate = operationData?.date
    ? format(new Date(operationData.date), DATE_FORMAT)
    : '';

  const operationType = operationTypesRealNames[operationData?.operationType];

  return (
    <div className="d-flex flex-column">
      <span className="mb-1">
        <b>{operationLabel}</b>
      </span>

      <span>
        <em className="icon ni ni-calendar text-muted mr-1" />
        {operationDate}
      </span>

      <span>
        <em className="icon ni ni-user text-muted mr-1" />
        {operationType}
      </span>
    </div>
  );
};
